import React from "react";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  CloseButton,
} from "@headlessui/react";
import { DateTime, Duration } from "luxon";
import { isWithinBusinessHours } from "@/utils/restaurantCartUtils";
import { isBusinessOpen } from "../notAcceptingOrdersBanner/notAcceptingOrdersBanner";

export const ScheduledOrderDropdown = ({
  scheduledOrder,
  setScheduledOrder,
  showScheduleScreen,
  leadTime,
  merchant,
  orderType,
}: {
  scheduledOrder: any;
  setScheduledOrder: any;
  showScheduleScreen: () => void;
  leadTime: any;
  merchant: any;
  orderType: string;
}) => {
  const now = new Date();
  const isOpen = isBusinessOpen(merchant);
  const currentDateTime = DateTime.fromJSDate(now, {
    zone: merchant.timezone,
  });
  const leadTimeDuration = Duration.fromObject({
    minutes: merchant.leadTime,
  });
  const targetPickupTime = currentDateTime.plus(leadTimeDuration);
  const merchantService = merchant.services.find(
    (s: any) => s.type === "PICKUP" || s.type === "WEBSITE"
  );
  const businessHours = merchantService?.hours;
  const { deliveryTime, pickupTime } = JSON.parse(
    global?.window?.localStorage.getItem("orderEstimates") || "{}"
  );

  const deliveryPickupTimeText = Math.round(
    (new Date(pickupTime).getTime() + leadTime * 60000 - Date.now()) / 1000 / 60
  );

  const deliveryTimeText = Math.round(
    (new Date(deliveryTime).getTime() + leadTime * 60000 - Date.now()) /
      1000 /
      60
  );

  const asapTime =
    deliveryTime && orderType === "delivery"
      ? [
          "ASAP",
          `(${deliveryPickupTimeText}`,
          "-",
          deliveryTimeText,
          "mins)",
        ].join(" ")
      : "ASAP (In " + leadTime + " mins)";

  const canShowASAP = isWithinBusinessHours(
    targetPickupTime,
    businessHours,
    merchant?.timezone,
    leadTime
  );

  const setAsapOrder = () => {
    global?.window?.localStorage.setItem(
      "scheduledTime",
      JSON.stringify({
        orderType: orderType,
        asap: true,
        date: {
          displayValue: "Today",
          dateObject: new Date(),
        },
        time: {
          displayValue: "",
          timeObject: new Date(now),
        },
      })
    );
    setScheduledOrder({
      type: "asap",
      epoch: targetPickupTime.toMillis(),
    });
  };

  return (
    <Popover className="relative">
      <PopoverButton
        className={[
          "flex",
          "items-center",
          "gap-x-2",
          "w-full",
          "leading-6",
          "text-gray-900",
          "hover:bg-gray-50",
          "disabled:hover:bg-transparent",
          "disabled:cursor-default",
        ].join(" ")}
        disabled={false}
      >
        <input
          type="text"
          id="scheduled_order_input"
          className="block px-2.5 h-[58px] py-2.5 w-full text-gray-900 bg-transparent rounded-[4px] border border-black hover:border-black focus:outline-none focus:ring-1 focus:ring-blue peer cursor-pointer disabled:border-transparent disabled:cursor-default"
          value={scheduledOrder?.type === "asap" ? asapTime : scheduledOrder}
          onChange={(e) => setScheduledOrder(e.target.value)}
          disabled={false}
        />
        <label
          htmlFor="scheduled_order_input"
          className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
        >
          For when?
        </label>
      </PopoverButton>
      <PopoverPanel
        transition
        className="absolute top-full z-20 w-full overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="p-3">
          {canShowASAP && (
            <CloseButton
              className="group relative flex w-full items-center gap-x-6 rounded-lg p-3 leading-6 hover:bg-gray-50"
              onClick={() => {
                setAsapOrder();
              }}
            >
              <div className="flex-auto">
                <p className="text-[15px]">{asapTime}</p>
              </div>
            </CloseButton>
          )}
          {isOpen && (
            <CloseButton
              className="group relative flex w-full items-center gap-x-6 rounded-lg p-3 leading-6 hover:bg-gray-50"
              onClick={() => {
                showScheduleScreen();
              }}
            >
              <div className="flex-auto">
                <p className="text-[15px]">Schedule an order</p>
              </div>
            </CloseButton>
          )}
        </div>
      </PopoverPanel>
    </Popover>
  );
};
